import type { SpaceGroup } from "@circle-react/types/SpaceGroup";
import { useMemo } from "react";

export interface SpaceGroupOption {
  label: string;
  value: number;
}

interface UseSpaceGroupSelectOptionsParams {
  spaceGroups: SpaceGroup[];
  value?: number | null;
}

export const useSpaceGroupSelectOptions = ({
  spaceGroups,
  value,
}: UseSpaceGroupSelectOptionsParams) => {
  const options = useMemo(
    (): SpaceGroupOption[] =>
      (spaceGroups ?? []).map(group => ({
        value: group.id,
        label: group.name,
      })),
    [spaceGroups],
  );

  const selectedOption = useMemo(
    (): SpaceGroupOption | null =>
      options.find(option => option.value === value) ?? null,
    [options, value],
  );

  return { options, selectedOption };
};
